export default {
    NO_ITEM_SELECTED: 'Вы не выбрали предмет для зачарования.',
    CANNOT_ENCHANT: 'Выбранный вами предмет не может быть зачарован.',
    NO_SHARD: 'Для зачарования предмета необходимо предоставить осколок.',
    FAILED_ENCHANT: 'Вы попробовали зачаровать, но ничего не получилось.',
    SUCCESSFUL_ENCHANT: 'Вы успешно зачаровали свой предмет.'
} as const;
